import { composeFetch } from '@library/http'
import { composeRequest, goustoHeaders, setServiceUrl } from '@library/http/requests'

import type { WelcomeExperienceResponse } from './interfaces'

const parseWelcomeExperience = async (response: Response): Promise<WelcomeExperienceResponse> => {
  if (!response.ok) {
    const responseMsg = await response.text()
    throw new Error(`service responded with ${response.status}: ${responseMsg}`)
  }

  return (await response.json()) as WelcomeExperienceResponse
}

export const getWelcomeExperience = composeFetch(
  composeRequest(setServiceUrl('onboardingexperienceapi', 1), goustoHeaders),
  parseWelcomeExperience,
)

export const getWelcomeHeader = getWelcomeExperience
